import { Pipe, type PipeTransform } from '@angular/core';

export enum Illustration {
    BINOCULARS = 'binoculars',
    COMPUTER = 'computer',
    FINGER_BEST_FOOD_IN_TOWN = 'finger-best-food-in-town',
    GOGGLES = 'goggles',
    MAN = 'man',
    OK_HAND = 'ok-hand',
    CROWN = 'crown',
}

@Pipe({
    name: 'illustrationPathResolver',
    standalone: true,
})
export class IllustrationPathResolverPipe implements PipeTransform {
    transform(key: string): string {
        return `/assets/illustrations/${key}.png`;
    }
}
